
export default {
  props: {
    tableData: {
      type: Object,
      default: null
    },
    rowspan: {
      type: String,
      default: null
    },
    nowrap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableBody: this.tableData.tbody
    }
  },
  methods: {
    rowspanCalc(cellIndex, row) {
      if (cellIndex === "0" && row[0].value) {
        return this.rowspan
      } else {
        return 1
      }
    },
    filterRow(row) {
      const rowArray = []

      for (const cell in row.body) {
        if (row.body[cell].value || row.body[cell].value === 0) {
          rowArray.push(row.body[cell])
        }
      }

      return { ...rowArray }
    }
  }
}
